export default function HomeSectionTitle({ title, className = "" }) {
  return (
    <div className={`self-end flex flex-col items-end gap-2 ${className}`}>
      <h2 className="text-xl lg:text-3xl text-black">{title}</h2>
      <hr className="w-20 border-t-4 border-black" />
    </div>
  )
}